import { render } from "./conversation.vue?vue&type=template&id=dcb5b54e"
import script from "./conversation.js?vue&type=script&lang=js"
export * from "./conversation.js?vue&type=script&lang=js"

import "./conversation.vue?vue&type=style&index=0&id=dcb5b54e&lang=scss"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__